




























































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetCatesInTest$, ComposeTest$ } from "@/request/jxgl";
@Component({})
export default class SjkAddRandomDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private test: any;
  private t: any = {
    随机选择: [],
  };
  private cates: any[] = [];
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  /**
   * @description 获得可选分类列表
   */
  private fetchCates() {
    GetCatesInTest$(this).then((data: any) => {
      this.cates = data;
    });
  }
  /**
   * @description 继续添加
   */
  private addOne() {
    this.t["随机选择"].push({ cate_id: "", count: 1 });
  }
  /**
   * @description 删除某项
   */
  private deleteThis(index) {
    this.t["随机选择"].splice(index, 1);
  }
  /**
   * @description 取消
   */
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  /**
   * @description 保存
   */
  private save() {
    ComposeTest$(this, this.t).then((data: any) => {
      this.$message.success("添加成功");
      this.$emit("testChange", data["test_id"]);
      this.$emit("update:ifVisible", false);
    });
  }
  private mounted() {
    this.fetchCates();
    this.t["试卷名称"] = this.test["试卷名称"];
    this.t.test_id = this.test.test_id;
  }
}
